// @core/api/endpoints/form/update_form_field.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  FormFieldResponse,
  UpdateFormFieldRequest,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Update form field
 * Updates a form field's label, type, validation, options, or conditional rules.
 */
export async function UpdateFormField(
  field_id: string,
  data: UpdateFormFieldRequest,
  options?: RequestOptions
): Promise<FormFieldResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/forms/fields/:field_id`;
  requestPath = requestPath.replace(':field_id', encodeURIComponent(field_id));
  const requestOptions = options;
  return client.put<FormFieldResponse>(requestPath, data, requestOptions);
}
